<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  import type { IInfoProps } from '@/components/ui/info/types'

  const props = withDefaults(defineProps<IInfoProps>(), {
    variant: 'primary',
    hasIcon: false
  })

  const base = computed(() =>
    cva('flex gap-4 rounded-sm p-6 text-bt-blue-dark', {
      variants: {
        variant: {
          primary: 'bg-light-info',
          secondary: 'bg-grey',
          outline: 'bg-white border border-divider'
        }
      }
    })({
      variant: props.variant
    })
  )

  const iconBase = computed(() =>
    cva('flex items-center justify-center rounded-full p-4', {
      variants: {
        variant: {
          primary: 'bg-white',
          secondary: 'bg-white',
          outline: 'bg-grey'
        }
      }
    })({
      variant: props.variant
    })
  )
</script>

<template>
  <div :class="base">
    <div v-if="hasIcon">
      <div :class="iconBase">
        <Icon name="common/outline-info" />
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-subtitle-2">{{ title }}</span>
      <p class="font-normal text-body-2 [&_a]:text-bt-blue-ui [&_a]:text-inherit">
        <slot
          v-if="$slots.content"
          name="content"
        />
        <span
          v-else
          v-html="text"
        />
      </p>
    </div>
  </div>
</template>
